export type PublicRuntimeEnv = ReturnType<typeof readConfig>;

let config: PublicRuntimeEnv;

const appConfig = typeof window === 'undefined' ? null : document.getElementById('__APP_CONFIG__');

const publicRuntimeConfig =
  typeof window === 'undefined' ? process.env : appConfig ? JSON.parse(appConfig.innerText) : {};

export function getPublicRuntimeEnv() {
  if (!config) config = readConfig();
  return config;
}

function readConfig() {
  return {
    AUTH0_DOMAIN: publicRuntimeConfig.AUTH0_DOMAIN as string,
    API_URL: publicRuntimeConfig.API_URL as string,
    PROMPT_URL: publicRuntimeConfig.PROMPT_URL as string,
    PAGES_URL: publicRuntimeConfig.PAGES_URL as string,
    ANTI_SHARING_URL: publicRuntimeConfig.ANTI_SHARING_URL as string,
    RECOVERY_STREAMS: publicRuntimeConfig.RECOVERY_STREAMS as string,
    LOGIN_URL: publicRuntimeConfig.LOGIN_URL as string,
    CHECKOUT_URL: publicRuntimeConfig.CHECKOUT_URL as string,
    MIT_TV2_URL: publicRuntimeConfig.MIT_TV2_URL as string,
    CLIENTSIDE_LOGGING_URL: publicRuntimeConfig.CLIENTSIDE_LOGGING_URL as string,
    TRACKING_ENV: publicRuntimeConfig.TRACKING_ENV as string,
    CONSENT_MODAL_URL: publicRuntimeConfig.CONSENT_MODAL_URL as string,
    COOKIE_DOMAIN: publicRuntimeConfig.COOKIE_DOMAIN as string,
    COOKIE_DOMAIN_SSO: publicRuntimeConfig.COOKIE_DOMAIN_SSO as string,
    COOKIE_BOT_URL: publicRuntimeConfig.COOKIE_BOT_URL as string,
    SERVICE_STATUS_URL: publicRuntimeConfig.SERVICE_STATUS_URL as string,
    PERMANENT_REDIRECTS_ENABLED: publicRuntimeConfig.PERMANENT_REDIRECTS_ENABLED as string,
    DATADOG_CLIENT_TOKEN: publicRuntimeConfig.DATADOG_CLIENT_TOKEN as string,
    APP_VERSION: publicRuntimeConfig.APP_VERSION as string,
  } as const;
}

export const buildtimeEnv = {
  PROTOCOL: warnOnMisingEnv(process.env.PROTOCOL, 'PROTOCOL'),
  APP_NAME: warnOnMisingEnv(process.env.APP_NAME, 'APP_NAME'),
  APP_VERSION: warnOnMisingEnv(process.env.APP_VERSION, 'APP_VERSION'),
} as const;

function warnOnMisingEnv(env: string | undefined, name?: string) {
  if (env) return env;
  // biome-ignore lint/suspicious/noConsole: Intentional console usage
  console.warn(`missing ENV: ${name}`);
  return '';
}
